import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button", "menu"]

    connect() {
        this.opened = false
    }

    toggle(event) {
        event?.preventDefault()
        event?.stopPropagation()

        this.opened ? this.close() : this.open()
    }

    open() {
        this.opened = true
        this.menuTarget.classList.remove("hidden")
        this.positionMenu()
    }

    close() {
        this.opened = false
        this.menuTarget.classList.add("hidden")
    }

    reposition() {
        if (!this.opened) return
        this.positionMenu()
    }

    positionMenu() {
        this.menuTarget.classList.remove("bottom-full", "mb-2")
        this.menuTarget.classList.add("top-full", "mt-2")

        const btnRect = this.buttonTarget.getBoundingClientRect()
        const menuRect = this.menuTarget.getBoundingClientRect()

        const spaceBelow = window.innerHeight - btnRect.bottom
        const spaceAbove = btnRect.top

        if (spaceBelow < menuRect.height && spaceAbove > spaceBelow) {
            this.menuTarget.classList.remove("top-full", "mt-2")
            this.menuTarget.classList.add("bottom-full", "mb-2")
        }
    }
}
